






import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import AdminLayout from '@/modules/common/layout/components/admin/AdminLayout.vue'
import AdminUserWalletUpdateForm from '@/modules/wallet/components/admin/AdminUserWalletUpdateForm.vue'
import AdminDashboardContent from '@/modules/dashboard/components/admin/AdminDashboardContent.vue'

@Component({
  layout: AdminLayout,
  layoutProps: {
    page_header: 'پیشخوان'
  },
  metaInfo: {
    title: 'پیشخوان'
  },
  components: {
    AdminDashboardContent,
    AdminUserWalletUpdateForm,
    AdminLayout
  }
})
export default class IndexPage extends Vue {
}
